var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "image 57 (Traced)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53728 1.31468C5.44518 1.83903 5.77513 3.16149 5.23149 4.09769C4.91082 4.64983 3.93898 5.17596 3.23937 5.17596C2.54128 5.17596 1.56791 4.64983 1.24863 4.10001C0.793706 3.31656 0.98622 2.0234 1.63739 1.48905C2.33672 0.914873 3.70301 0.83275 4.53728 1.31468ZM17.3319 6.95803C18.2479 7.3477 19.1639 8.3236 19.5844 9.35753C19.906 10.1485 19.9167 10.2977 19.9576 14.5859L20 19H17.986H15.9722L15.9713 15.4071C15.9709 13.2214 15.9111 11.6024 15.8187 11.2732C15.6192 10.5625 14.9156 9.87709 14.261 9.75555C13.4948 9.61348 12.5886 10.0015 12.0867 10.6866L11.6818 11.2394V15.1197V19H9.60576H7.52976V12.9092V6.81842H9.60576H11.6818V7.64444V8.47046L12.1131 7.98457C12.7128 7.30897 13.2875 6.92997 14.0261 6.72275C14.9031 6.47652 16.4608 6.58752 17.3319 6.95803ZM5.31537 12.9092V19H3.23937H1.16337V12.9092V6.81842H3.23937H5.31537V12.9092Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.bb17b9155fbb2f61eb6cc3e4f4247c99.svg";
export { ForwardRef as ReactComponent };